import React from 'react';
import { Flex } from '../Flex';
import { Text } from '../Text';
import { VisuallyHidden } from '../VisuallyHidden';
const PriceLabel = _ref => {
  let {
    price,
    caption
  } = _ref;
  return React.createElement(Flex, {
    justifyContent: "flex-end",
    alignItems: "center",
    flexDirection: "column"
  }, React.createElement(Text.BodyMedium, {
    marginBottom: "--spacing-0-5",
    weight: "bold"
  }, React.createElement(VisuallyHidden, null, "Pre\u00E7o: "), price), React.createElement(Text.Caption, null, caption));
};
export default PriceLabel;